<div [ngStyle]="containerStyle" (mouseenter)="onMouseEnter()" (mouseleave)="onMouseLeave()">
  <div class="announcement-bar__stack">
    @for (msg of renderedMessages; track $index) {
      <div class="announcement-bar__sizer" [innerHTML]="msg"></div>
    }
    <div
      class="announcement-bar__message"
      [class]="phaseClass"
      [style.color]="currentMessageColor || null"
      [innerHTML]="renderedMessage"></div>
  </div>
</div>
